import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withJob } from 'react-jobs'
import { createStructuredSelector } from 'reselect'
import { bindPromiseCreators } from '../../utils/routines'

import { withApplicationsReducer } from './reducer'
import { withFetchApplyByIdSaga, withApplyStepSaga } from './saga'
import { createFetchApplyByIdPromise } from './routines'
import { setCurrentApplication } from './actions'
import { selectApplyByParamsId } from './selectors'

import ApplicationsRequesting from './components/ApplicationsRequesting'
import ApplicationsError from './components/ApplicationsError'

// connector
const mapStateToProps = createStructuredSelector({
  application: selectApplyByParamsId
})
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    setCurrentApplication
  }, dispatch),
  ...bindPromiseCreators({
    fetchApplyById: createFetchApplyByIdPromise
  }, dispatch)
})
const connector = connect(mapStateToProps, mapDispatchToProps)

// job
function work(props) {
  if (!props.application) {
    return props.fetchApplyById(props.match.params.id)
  }

  return props.setCurrentApplication(props.match.params.id)
}

const job = withJob({
  work,
  LoadingComponent: ApplicationsRequesting,
  ErrorComponent: ApplicationsError
})

// enhancer
const enhancer = compose(
  withApplicationsReducer,
  withFetchApplyByIdSaga,
  withApplyStepSaga,
  connector,
  job
)

export default enhancer
